import { isSmallScreen } from 'Utils/Misc'
import * as CONST from './const'
import { UNBOOK_REASONS } from '../../shared/constants'

const defaultState = {
  mainSidebarOpen: isSmallScreen() ? false : true,
  filters: {
    'masterSchedule': {
      'client': null,
      'week': null,
      'location': null,
      'status': null,
    },
  },
  unbookModal: {
    show: false,
    reason: UNBOOK_REASONS.CLIENT_REQUEST,
    onConfirm: null,
  },
  reduxModal: {
    show: false,
    title: 'Modal',
    onConfirm: null,
    onCancel: null, // Optional
    children: null, // Optional
    confirmDisabled: false, // Optional
  },
}

export const ui = function(state = defaultState, action) {
  switch (action.type) {
    case CONST.OPEN_MAIN_SIDE_BAR:
      return {
        ...state,
        mainSidebarOpen: true,
      }
    case CONST.CLOSE_MAIN_SIDE_BAR:
      return {
        ...state,
        mainSidebarOpen: false,
      }
    case CONST.UPDATE_FILTER_VALUE:
      const { filterGroup, name, value } = action.payload
      return {
        ...state,
        filters: {
          ...state.filters,
          [filterGroup]: {
            ...state.filters[filterGroup],
            [name]: value,
          },
        },
      }
    case CONST.SHOW_UNBOOK_MODAL:
      const { onConfirm, title, text } = action.payload

      return {
        ...state,
        unbookModal: {
          ...state.unbookModal,
          show: true,
          onConfirm,
          title,
          text,
        },
      }
    case CONST.UNBOOK_MODAL_CHANGE:
      const { reason } = action.payload
      return {
        ...state,
        unbookModal: {
          ...state.unbookModal,
          reason,
        },
      }
    case CONST.HIDE_UNBOOK_MODAL:
      return {
        ...state,
        unbookModal: {
          ...state.unbookModal,
          show: false,
        },
      }

    case CONST.SHOW_REDUX_MODAL:
      return {
        ...state,
        reduxModal: {
          ...action.payload,
          show: true,
        },
      }

    case CONST.HIDE_REDUX_MODAL:
      return {
        ...state,
        reduxModal: {
          ...state.reduxModal,
          show: false,
        },
      }
    case CONST.RESET_REDUX_MODAL:
      return {
        ...state,
        reduxModal: {
          ...defaultState.reduxModal,
        },
      }
    case CONST.TOGGLE_CONFIRM_AVAILABILITY_REDUX_MODAL:
      return {
        ...state,
        reduxModal: {
          ...state.reduxModal,
          confirmDisabled: !state.reduxModal.confirmDisabled,
        },
      }
    default:
      return state
  }
}
